import { createSelector } from 'reselect';
import { getMachine } from './getMachine';
import { getIsMESEnabled } from './getIsMESEnabled';
import { getMachineSettings } from './getMachineSettings';

// TODO: resource.machineRef is being deprecated. The { resource: { machineRef } } branch below
// covers labor tickets whose machineRef is null and fall back to the linked resource's machineRef.
// Once labor ticket.machineRef is always populated, this fallback can be dropped.
/** @param {number|string} machineRef */
function whereMachineRefOrLegacyResourceLink(machineRef) {
  return {
    _or: [
      { machineRef: { _eq: machineRef } },
      {
        _and: [
          { machineRef: { _is_null: true } },
          { resource: { machineRef: { _eq: machineRef } } },
        ],
      },
    ],
  };
}

/** @param {number|string} machineRef @param {string} laborResourceId */
function whereMachineRefOrLaborResourceLink(machineRef, laborResourceId) {
  return {
    _or: [
      { machineRef: { _eq: machineRef } },
      {
        _and: [
          { machineRef: { _is_null: true } },
          { resourceId: { _eq: laborResourceId } },
        ],
      },
    ],
  };
}

export const getLaborTicketWhereForMachine = createSelector(
  [getMachine, getIsMESEnabled, getMachineSettings],
  (machine, isMesEnabled, machineSettings) => {
    const { machineRef } = machine;
    const { laborResourceId } = machineSettings || {};

    if (!isMesEnabled) {
      return whereMachineRefOrLegacyResourceLink(machineRef);
    }

    if (laborResourceId != null && laborResourceId !== '') {
      return whereMachineRefOrLaborResourceLink(machineRef, laborResourceId);
    }

    return whereMachineRefOrLegacyResourceLink(machineRef);
  }
);
